// extracted by mini-css-extract-plugin
export default {"wrapper":"Nl-z","response":"Ol-z","error":"Pl-z","disabled":"Ql-z","buttons":"Rl-z","feedbackQuestionSection":"Sl-z","yesNoWrapper":"Tl-z"};